<template>
  <div class="macro">
    <macro-tab1 :lists="$attrs.lists" :total="$attrs.total" v-on="$listeners"></macro-tab1>
  </div>
</template>

<script>
import MacroTab1 from "../../comLeft/macroTab1";
export default {
  props: {},

  components: {
    MacroTab1,
  },

  data() {
    return {
    };
  },

  created() {},

  methods: {}
};
</script>

<style scoped>
.macro {
  height: 100%;
}
</style>